import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Login} from '../../model/security/login';

export class LoginForm {

  static getForm(login?: Login): FormGroup {
    const controls = {};
    // @ts-ignore
    controls[LoginForm.FIELDS.LOGIN] = new FormControl(login ? login.login : '', [Validators.maxLength(100), Validators.required]);
    // @ts-ignore
    controls[LoginForm.FIELDS.PASSWORD] = new FormControl(login ? login.login : '', [Validators.maxLength(100), Validators.required]);

    return new FormGroup(controls);
  }

  static getValue(loginForm?: FormGroup): Login {
    const login = new Login();
    // @ts-ignore
    login.login = loginForm.get(LoginForm.FIELDS.LOGIN).value;
    // @ts-ignore
    login.password = loginForm.get(LoginForm.FIELDS.PASSWORD).value;

    return login;
  }

  static setValue(loginForm?: FormGroup, login?: Login): void {
    loginForm.get(LoginForm.FIELDS.LOGIN).setValue(login.login);
    loginForm.get(LoginForm.FIELDS.PASSWORD).setValue(login.password);
  }
}

export module LoginForm {
  export enum FIELDS {
    _NAME = 'login_information',
    PASSWORD = 'password',
    LOGIN = 'login'
  }
}

